
import { Component, Vue } from 'vue-property-decorator';
import { State, Mutation } from 'vuex-class';
import { AirboltsViewType } from '@/types/store/state';
import { mutations } from '@/store/types';
import { SetViewTypeMutationType } from '@/types/store/mutations';

@Component({
    components: {},
})
export default class ListViewMenu extends Vue {
    protected items = [
        {
            icon: '$mdiViewDay',
            text: 'Combo view',
            type: AirboltsViewType.Combo,
        },
        {
            icon: '$mdiViewModule',
            text: 'Grid view',
            type: AirboltsViewType.Grid,
        },
        {
            icon: '$mdiViewList',
            text: 'List view',
            type: AirboltsViewType.List,
        },
    ];

    @State('viewType')
    viewType!: AirboltsViewType;

    @Mutation(mutations.SET_VIEW_TYPES)
    setViewType!: SetViewTypeMutationType;

    get currentViewType() {
        return this.items.find((item) => item.type === this.viewType);
    }
}
